import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    fetch('/content.json')
      .then(response => response.json())
      .then(data => {
        setContact(data.contact);
      })
      .catch(err => console.error('Error loading contact:', err));
  }, []);

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_strange-montalcini/artifacts/zyrmjwje_LOGO.png" 
              alt="EduBrisk Logo" 
              className="footer-logo"
            />
            <h3 className="footer-heading">Inclusive School Leaders Retreat</h3>
            <p className="footer-text">
              Empowering school leaders to create inclusive, equitable learning environments through evidence-based practices and transformational leadership.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subheading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/#about">About the Retreat</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/#participants">Participants</Link></li>
              <li><Link to="/#facilitators">Facilitators</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subheading">Contact Us</h4>
            {contact && (
              <ul className="footer-contact">
                <li>
                  <Mail className="footer-icon" />
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </li>
                <li>
                  <Phone className="footer-icon" />
                  <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                </li>
                <li>
                  <MapPin className="footer-icon" />
                  <span>{contact.address}</span>
                </li>
              </ul>
            )}
          </div>

          {/* Social Media */}
          <div className="footer-section">
            <h4 className="footer-subheading">Follow Us</h4>
            {contact && (
              <div className="footer-social">
                <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <Linkedin className="social-icon" />
                </a>
                <a href={contact.facebook} target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <Facebook className="social-icon" />
                </a>
                <a href={contact.instagram} target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <Instagram className="social-icon" />
                </a>
              </div>
            )}
            <p className="footer-text mt-4">
              Stay updated with our latest events and insights on inclusive education leadership.
            </p>
          </div>
        </div>

        <Separator className="footer-separator" />

        {/* Powered By Section */}
        <div className="powered-by-section">
          <p className="powered-by-text">Powered by</p>
          <img 
            src="https://customer-assets.emergentagent.com/job_strange-montalcini/artifacts/ttyhx4nb_Edubrisk-Logo.jpg" 
            alt="Powered by EduBrisk" 
            className="powered-by-logo"
          />
        </div>

        <Separator className="footer-separator" />

        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} EduBrisk - Inclusive School Leaders Retreat. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="#">Privacy Policy</Link>
            <Link to="#">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
